import _ from "lodash";
import api from "CommonCore/api";
import {
  emptyOrFalse,
  setupLookups,
} from "App/shk-form-tab";
import {
  ASTMODUSKEY,
  getModusFromAntrag,
} from "App/constants";

const istKeinTarifvertrag = {
  inject: ["flag_antragstellermodus", "currentAntrag"],
  generator: (modus, antrag) => () => (modus !== undefined ? modus : antrag && getModusFromAntrag(antrag)) !== ASTMODUSKEY.Tarif,
};

const istTarifvertrag = {
  inject: ["flag_antragstellermodus", "currentAntrag"],
  generator: (modus, antrag) => () => (modus !== undefined ? modus : antrag && getModusFromAntrag(antrag)) === ASTMODUSKEY.Tarif,
};

export const schema = {
  displayName: "Person/LBV Person",
  table: [
    {
      field: "lbp_lbv_jn",
      display: "Haben Sie bereits Bezüge vom LBV NRW erhalten?",
      lookup: "boolean.radioheader2",
      required: true,
      dependends: [
        {
          fields: ["lbp_lbv_nummer", "lbp_bezuege_von", "lbp_bezuege_bis", "lbp_bezuege_art", "lbp_bezuege_overlap_jn"],
          invisibleIf: emptyOrFalse,
        },
      ],
      subtag: "lbv",
    },
    {
      field: "lbp_lbv_nummer",
      display: "Personalnummer des LBV",
      maxlength: 10,

      /*
       * validate: value => {
       *  if (value && (value.length>10 || !value.toLowerCase().startsWith('q60'))) {
       *    return "Die Personalnummer muss mit Q60 beginnen und darf nicht länger als 10 Zeichen sein"
       *  }
       * }
       */
    },
    {
      field: "lbp_bezuege_von",
      display: "Von",
      type: "date",
      subtag: "lbv",
    },
    {
      field: "lbp_bezuege_bis",
      display: "Bis",
      type: "date",
      subtag: "lbv",
    },
    {
      field: "lbp_bezuege_art",
      display: "Aufgaben / Stellenkategorie",
      maxlength: 30,
      subtag: "lbv",
    },
    {
      field: "lbp_bezuege_overlap_jn",
      display: "Ich habe von einer anderen Dienststelle des öffentlichen Dienstes für den Einstellungsmonat und darüber hinaus Bezüge erhalten:",
      lookup: "boolean.radioheader2",
      required: true,
      dependends: [
        {
          fields: ["lbp_bezuege_overlap_von", "lbp_bezuege_overlap_bis", "lbp_bezuege_overlap_dienststelle"],
          invisibleIf: emptyOrFalse,
        },
      ],
      inject: ["flag_antragstellermodus", "currentAntrag"],
      hideFromDetail: istKeinTarifvertrag,
      hideFromEditor: istKeinTarifvertrag,
      subtag: "lbv",
    },
    {
      field: "lbp_bezuege_overlap_von",
      display: "Von",
      type: "date",
      subtag: "lbv",
    },
    {
      field: "lbp_bezuege_overlap_bis",
      display: "Bis",
      type: "date",
      subtag: "lbv",
    },
    {
      field: "lbp_bezuege_overlap_dienststelle",
      display: "Dienststelle",
      subtag: "lbv",
    },
    {
      field: "lbp_kg_jn",
      display: "Haben Sie Anspruch auf Kindergeld für ein eigenes Kind?",
      lookup: "boolean.radioheader2",
      dependends: [
        {
          fields: ["lbp_kg_antrag_jn"],
          invisibleIf: emptyOrFalse,
        },
      ],
      required: true,
      subtag: "kinder",
      hideFromDetail: istTarifvertrag,
      hideFromEditor: istTarifvertrag,
    },
    {
      field: "lbp_kg_jn",
      display: "Haben Sie Anspruch auf Kindergeld für ein oder mehrere Kind(er)?",
      lookup: "boolean.radioheader2",
      dependends: [
        {
          fields: ["lbp_kg_antrag_jn"],
          invisibleIf: emptyOrFalse,
        },
      ],
      required: true,
      subtag: "kinder",
      hideFromDetail: istKeinTarifvertrag,
      hideFromEditor: istKeinTarifvertrag,
    },
    {
      field: "lbp_kg_antrag_jn",
      display: "Kindergeldbescheid",
      lookup: {
        editType: "radioheader2",
        values: [{ value: true, label: "ist beigefügt" },
                 { value: false, label: "wird nachgereicht" }],
      },
      sortable: true,
      subtag: "kinder",
    },

    {
      field: "lbp_steuerid",
      display: "Steuer-ID",
      maxlength: 11,
      helpText: "Die Steuer-ID wird für den elektronischen Abruf Ihrer Steuermerkmale benötigt. Ohne elektronischen Abruf Ihrer ELStAM ist das LBV verpflichtet, Ihre Bezüge nach Steuerklasse VI zu versteuern.",
      validate: (value, entity) => {
        if (_.isEmpty(value)) {
          if (entity.lbp_lohnsteuerabzug_jn) {
            return;
          }

          return "Keine Steuer-ID angegeben";
        }

        if (value && (value.length < 11 || isNaN(value))) {
          return "Die Steuer-ID muss eine 11-stellige Ganzzahl sein";
        }

        // Prfüziffer checken
        let summe = 0;
        let produkt = 10;

        for (let i = 0; i <= 9; i++) {
          summe = (parseInt(value[i]) + produkt) % 10;
          if (summe == 0) {
            summe = 10;
          }
          produkt = (summe * 2) % 11;
        }
        let ziffer = 11 - produkt;
        if (ziffer == 10) {
          ziffer = 0;
        }
        if (value[10] != ziffer) {
          return "Die Steuer-ID ist nicht gültig";
        }
      },
      subtag: "steuer",
    },
    {
      field: "lbp_lohnsteuerabzug_jn",
      display: "Ich habe keine Steuer-ID; Bescheinigung Lohnsteuerabzug des Wohnsitzfinanzamts ist beigefügt",
      initValue: false,

      hideFromDetail: (entity, args) => {
        if (!args.readonly) {
          return false; // im Editmode immer anzeigen
        }
        return !entity || !entity.lbp_lohnsteuerabzug_jn; // Im Readonly nur anzeigen wenn nein (d.h. ID vorhanden)
      },

      lookup: "boolean.checkbox",
      subtag: "steuer",
    },


    {
      field: "lbp_hauptarbeit_jn",
      display: "Bei der vorliegenden Beschäftigung handelt es sich um mein",
      type: "radioheader2",
      initValue: true, // default: Hauptverhältnis
      choices: [{ value: true, label: "Hauptarbeitsverhältnis" },
                { value: false, label: "Nebenarbeitsverhältnis" }],
      selector: value => value == null ? "" : value ? "Hauptarbeitsverhältnis" : "Nebenarbeitsverhältnis",
      dependends: [
        {
          fields: ["lbp_steuerklasse", "lbp_kinderfreibetrag", "lbp_freibetrag", "lbp_ast_kkiid", "lbp_partner_kkiid"],
          invisibleIf: value => {
            return !value;
          },
          noContainer: true,
        },
        {
          fields: ["lbp_hinzurechnungsbetrag"],
          invisibleIf: value => {
            return value;
          },
          noContainer: true,
        },
      ],
      subtag: "steuer",
    },
    {
      field: "lbp_steuerklasse",
      display: "Steuerklasse",
      maxlength: 2, // 22.10.2018 TH: PBP-1527
      sortable: true,
      subtag: "steuer",
    },
    {
      field: "lbp_kinderfreibetrag",
      display: "Kinderfreibetrag (in EUR)",
      type: "money",
      sortable: true,
      subtag: "steuer",
    },
    {
      field: "lbp_freibetrag",
      display: "Steuerfreibetrag (in EUR)",
      type: "money",
      sortable: true,
      subtag: "steuer",
    },
    {
      field: "lbp_ast_kkiid",
      display: "Kirchensteuer",
      lookup: "k_kirchensteuer.select.kki_id.kki_bez",
      subtag: "steuer",
    },
    {
      field: "lbp_partner_kkiid",
      display: "Kirchensteuer des Partners (falls relevant)",
      lookup: "k_kirchensteuer.select.kki_id.kki_bez",
      subtag: "steuer",
    },
    {
      field: "lbp_hinzurechnungsbetrag",
      display: "ggf. Freibetrag aufgrund eines Hinzurechnungsbetrages",
      type: "money",
      subtag: "steuer",
    },
    {
      field: "lbp_auslandswohnsitz_jn",
      display: "Liegt ihr Wohnsitz im Ausland?",
      lookup: "boolean.radioheader2",
      dependends: [
        {
          fields: ["lbp_lsta_fa"],
          invisibleIf: value => {
            return !value;
          },
        },
      ],
      subtag: "steuer",
    },
    {
      field: "lbp_lsta_fa",
      display: "Bescheinigung des Betriebsstättenfinanzamts",
      lookup: {
        editType: "radioheader2",
        values: [{ value: true, label: "ist beigefügt" },
                 { value: false, label: "ist beantragt" }],
      },
      subtag: "steuer",
    },
    {
      field: "lbp_pauschalsteuer_jn",
      display: "Die Bezüge sollen nicht nach meinen individuellen Steuermerkmalen, sondern pauschal versteuert werden. Die Erklärung für die Übernahme der Pauschsteuer (LBV(A)02.PS...) ist beigefügt",
      lookup: "boolean.radioheader2",
      subtag: "steuer",
    },

  ],
};

// Fields anreichern
schema.table = setupLookups(schema);

const desc = {
  id: "p_id",
  name: "lbvperson",
  endpoint: "/api/shkperson/lbvperson",
  schema,
  breadcrumbs: {
    list: "Persönliche Daten LBV",
    detail: ba => ba.ba_kbez,
  },
};

const personlbvApi = api(desc);
export default personlbvApi;

